module.exports = __webpack_public_path__ + "assets/img/lm.0a4b3262.png";